<template>
  <div>
    <!-- Inform about employee does not exit error -->
    <v-container v-if="employeeDoesNotExist">
      <v-row>
        <v-col class="text-center mt-12 grand-error">
          <b>Töötajat ei leitud</b><br />
          Töötajat IDga {{ employeeId }} ei ole olemas<br />
          või puudub sul ligipääsu tema andmetele.
        </v-col>
      </v-row>
    </v-container>

    <!-- Main -->
    <v-container v-else>
      <v-row>
        <v-avatar size="70">
          <img :src="employee.avatar" alt="employee profile picture" />
        </v-avatar>
        <v-col class="pl-4">
          <h1 :id="'header-for-employee-' + employee.id">
            {{ employee.username }}
          </h1>
        </v-col>
        <v-col class="text-right">
          <v-btn
            v-if="user.isAdminOrSuperuser"
            color="secondary"
            small
            text
            @click="redirectToAdminChangePage()"
          >
            <v-icon>edit</v-icon>
            <template v-if="!this.$vuetify.breakpoint.xsOnly">
              Vaata töötaja andmeid
            </template>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <Calendar :person-id="employeeId" person-type="employee" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Calendar from '@/components/Calendar/index.vue'
import { DoesNotExist } from '@/dataAccess/store'
import Employee from '@/dataAccess/models/Employee'

export default {
  components: { Calendar },
  props: {
    employeeId: {
      type: Number,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      employee: null,
      employeeDoesNotExist: false
    }
  },
  created() {
    try {
      this.employee = Employee.find(this.employeeId)
    } catch (e) {
      if (e instanceof DoesNotExist) {
        this.employeeDoesNotExist = true
      } else {
        throw e
      }
    }
  },
  methods: {
    redirectToAdminChangePage() {
      window.location.replace(this.employee.adminChangeUrl)
    }
  }
}
</script>

<style>
.expansion-panel__header {
  padding-left: inherit;
}

.v-expansion-panel {
  box-shadow: none;
  -webkit-box-shadow: none;
}

.theme--light .v-expansion-panel .v-expansion-panel__container,
.application .theme--light.v-expansion-panel .v-expansion-panel__container {
  background-color: inherit;
}
</style>
